import { FunctionComponent } from 'preact';
import { Stack } from 'components/Stack';
import { useTranslation } from 'react-i18next';
import { Title, Comment } from './CommentSection.styles';

interface CommentSectionProps {
  comment?: string;
}

const CommentSection: FunctionComponent<CommentSectionProps> = ({
  comment,
}) => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" gap={8} isFullWidth>
      <Title>{t('RETURN_COMMENTS')}:</Title>
      <Comment>{comment || '-'}</Comment>
    </Stack>
  );
};

export { CommentSection };
